import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import * as userSettingsActions from "../../../users/actions/userSettings";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";
import analytics from "../../../utils/analytics";

import styles from "./SaveTag.css";

import Icon from "../Icon";

class SaveTag extends Component {
  constructor() {
    super();

    this.state = {
      saved: false,
    };

    this.saveStory = this.saveStory.bind(this);
  }

  componentDidMount() {
    if (this.props.userSettings && this.props.userSettings.data.profileInfo.savedStoryIds.indexOf(this.props.storyId) >= 0) {
      this.setState({
        saved: true,
      });
    }
  }

  saveStory() {
    // If we are not logged in, open the auth drawer
    if (!this.props.authDrawer.loggedIn) {
      this.props.authDrawerActions.changeStep(authDrawerConstants.SIGNIN);
      return this.props.authDrawerActions.toggleAuthDrawer(true);
    }

    const savedStories = this.props.userSettings.data.profileInfo.savedStoryIds;

    // Save a story if not already saved
    if (savedStories && savedStories.indexOf(this.props.storyId) < 0) {
      analytics.userClicksSaveTag(this.props.stream);
      const newSavedStories = savedStories.concat(this.props.storyId);

      this
        .props
        .userSettingsActions.submitSavedStories(newSavedStories)
        .then(() => {
          this.setState({
            saved: true,
          });
        });
    }

    // Remove a saved story if previously saved
    if (savedStories && savedStories.indexOf(this.props.storyId) >= 0) {
      const newSavedStories = savedStories.filter((savedStory) => {
        return savedStory !== this.props.storyId;
      });

      this
        .props
        .userSettingsActions.submitSavedStories(newSavedStories)
        .then(() => {
          this.setState({
            saved: false,
          });
        });
    }
  }

  render() {
    return (
      <div onClick={this.saveStory} className={classNames(styles.root, this.props.absolute ? styles.absolute : {})}>
        {!this.state.saved && <span className={styles.save}>Save</span>}
        <Icon name="save" description="Save story" className={classNames(styles.icon, this.state.saved ? styles.saved : {})} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveTag);



// WEBPACK FOOTER //
// ./src/components/Library/SaveTag/SaveTag.js